export default __webpack_public_path__ + "static/media/truck.242e1e3a.svg";